export default __webpack_public_path__ + "static/media/love.042dfb21.jpg";